import { Skeleton, Stack, Box, Typography } from "@mui/material";

type Props = {};

const DailyPOBReportSummaryLoading = (props: Props) => {
  return (
    <Stack
      direction={"row"}
      paddingY={3}
      borderRadius={"20px"}
      justifyContent={"space-around"}
      bgcolor={"#f9fafd"}
    >
      <Stack marginX={3}>
        <Skeleton width={120} height={20} />
        <Skeleton width={80} height={30} />
        <Skeleton width={150} height={20} />
      </Stack>
      <Box borderRight="2px solid #e1e3e2" />
      <Stack marginX={3}>
        <Skeleton width={100} height={20} />
        <Skeleton width={80} height={30} />
        <Skeleton width={150} height={20} />
      </Stack>
      <Box borderRight="2px solid #e1e3e2" />
      <Stack marginX={3}>
        <Skeleton width={120} height={20} />
        <Skeleton width={80} height={30} />
        <Skeleton width={150} height={20} />
      </Stack>
      <Box borderRight="2px solid #e1e3e2" />
      <Stack marginX={3}>
        <Skeleton width={80} height={20} />
        <Skeleton width={80} height={30} />
        <Skeleton width={150} height={20} />
      </Stack>
    </Stack>
  );
};

export default DailyPOBReportSummaryLoading;
